/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto } from '../models/Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DisbursementValidationConfigService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppDisbursementValidationConfigUpsertValidationRule(
requestBody?: Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/disbursement-validation-config/upsert-validation-rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementValidationConfigValidationRule(): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement-validation-config/validation-rule',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
